@file:OptIn(InternalResourceApi::class)

package bingeamigo.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/bingeamigo.composeapp.generated.resources/"

internal val Res.drawable.binge_amigo_header: DrawableResource by lazy {
      DrawableResource("drawable:binge_amigo_header", setOf(
        ResourceItem(setOf(), "${MD}drawable/binge-amigo-header.png", -1, -1),
      ))
    }

internal val Res.drawable.binge_amigo_logo: DrawableResource by lazy {
      DrawableResource("drawable:binge_amigo_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/binge-amigo-logo.png", -1, -1),
      ))
    }

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("binge_amigo_header", Res.drawable.binge_amigo_header)
  map.put("binge_amigo_logo", Res.drawable.binge_amigo_logo)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
}
